/**
 * Language selector component.
 * @module components/LanguageSelector/LanguageSelector
 */

import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { toReactIntlLang } from '@plone/volto/helpers/Utils/Utils';

import config from '@plone/volto/registry';

import Button from '../Button';
import Icon from '../Icon';

const LanguageSelector = (props) => {
  const currentLang = useSelector((state) => state.intl.locale);

  const { settings } = config;

  return settings.isMultilingual ? (
    <div className="language-selector">
      <Button
        href={currentLang === 'en' ? '/pt-br' : '/en'}
        onClick={() => {
          props.onClickAction();
        }}
      >
        <Icon name="language" />
        {currentLang === 'en' ? 'Português' : 'English'}
      </Button>
    </div>
  ) : (
    <Helmet>
      <html lang={toReactIntlLang(settings.defaultLanguage)} />
    </Helmet>
  );
};

LanguageSelector.propTypes = {
  onClickAction: PropTypes.func,
};

LanguageSelector.defaultProps = {
  onClickAction: () => {},
};

export default LanguageSelector;
